import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class MultiFilesService {

  private baseUrl = 'https://www.ha-software.com/backendnodedatabase/upload';
  private identity;
  private token;
  public url: string;

  constructor(private http: HttpClient) {
    this.token = JSON.parse(localStorage.getItem("token"));
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.url = GLOBAL.url;
  }

  upload(file: File, idfather = null, type = ''): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);
    formData.append('idpaciente', this.identity.sub);
    formData.append('idfather', idfather);
    formData.append('type', type);

    const req = new HttpRequest('POST', `${this.baseUrl}`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  getFiles(token, father, type): Observable<any> {
    let params = "authorization="+token+"&type="+type+'&father='+0;
    let headers = new HttpHeaders({'Content-Type':'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest'});

    return this.http.post(this.url+'/image/detailusertype/'+father+'?page=1', params, {headers: headers}).pipe(map(res => res));
  }

  removeFile(token, id) {
    let params = "authorization="+token;
    let headers = new HttpHeaders({'Content-Type':'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest'});
    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this.http.post(this.url+'/image/remove/'+id+'?page='+page, params, {headers: headers}).pipe(map(res => res));
  }
}
